import { render } from "./HeroiconsOutlineArrowNarrowUp.vue?vue&type=template&id=3c155050"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowNarrowUp.vue"]])

export default __exports__